import { Component, ElementRef, ViewChild } from '@angular/core';
import {IHeaderAngularComp} from "ag-grid-angular";
import { IHeaderParams } from 'ag-grid-community';
import {HeaderService} from "./header.service";


@Component({
  selector: 'app-loading-overlay',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss'],
})
export class CustomHeaderComponent implements IHeaderAngularComp {

  params: any;

  ascSort: string | undefined;
  descSort: string | undefined;
  noSort: string | undefined;

  @ViewChild('menuButton', { read: ElementRef }) public menuButton: any;

  constructor(private headerService: HeaderService) {
  }

  refresh(params: IHeaderParams): boolean {
    return true;
  }

  agInit(params: IHeaderParams): void {
    this.params = params;


    // params.column.addEventListener(
    //   'sortChanged',
    //   this.onSortChanged.bind(this)
    // );
    //
    // this.onSortChanged();
  }

  onMenuClicked(event: any): void {
    this.params.showColumnMenu(this.menuButton.nativeElement);
  }

  // onSortChanged() {
  //   this.ascSort = this.descSort = this.noSort = 'inactive';
  //   if (this.params.column.isSortAscending()) {
  //     this.ascSort = 'active';
  //   } else if (this.params.column.isSortDescending()) {
  //     this.descSort = 'active';
  //   } else {
  //     this.noSort = 'active';
  //   }
  // }

  // onSortRequested(order: string, event: any) {
  //   console.log(this.params);
  //   this.params.setSort(order, event.shiftKey);
  // }
  remove(): void {
    this.headerService.removeHeader(this.params.displayName);
  }
}
